import InfoOutlineIcon from "@mui/icons-material/InfoOutline";
import { Tooltip, type TooltipProps } from "@mui/material";
import { type FC } from "react";

export const PreviewTooltip: FC<Omit<TooltipProps, "children">> = (props) => {
  return (
    <Tooltip {...props}>
      <InfoOutlineIcon fontSize="small" />
    </Tooltip>
  );
};
